import { BaseFooter, Footer } from "@product/scmp-sdk";
import { memo } from "react";
import type { FunctionComponent } from "react";

import { Portal } from "~/components/common/portal";
import { useNewsletterWidget } from "~/components/newsletter/newsletter-widget-container/hooks";
import { PostiesFooter } from "~/components/posties/footer";
import { FooterElementID } from "~/pages/_app/consts";

import { Container } from "./styles";

export type FooterVariant = "posties";

export type Props = {
  className?: string;
  hasPrintEditionFooter?: boolean;
  variant?: FooterVariant;
};

const AppFooter_: FunctionComponent<Props> = ({ className, hasPrintEditionFooter, variant }) => {
  const { dataMatrix } = useNewsletterWidget({
    contentType: "footer",
    eventCategory: "Newsletter (Footer - Inline)",
    section: "",
  });

  const renderFooter = () => {
    switch (variant) {
      case "posties":
        return <PostiesFooter />;
      default:
        return (
          <BaseFooter
            dataMatrix={dataMatrix}
            newsletterItems={[]}
            queryParametersForSocialButtons={queryParametersForSocialButtons}
          />
        );
    }
  };

  const queryParametersForSocialButtons = {};
  return (
    <Portal selector={`#${FooterElementID}`}>
      <Container className={className}>
        {hasPrintEditionFooter ? (
          <Footer
            dataMatrix={dataMatrix}
            queryParametersForSocialButtons={queryParametersForSocialButtons}
          />
        ) : (
          renderFooter()
        )}
      </Container>
    </Portal>
  );
};

export const AppFooter = memo(AppFooter_);

AppFooter.displayName = "AppFooter";
